module.exports = __webpack_public_path__ + "static/media/dad1.8bd181a5.jpg";